let SiteVisitAuthorHelper = (props, isVenueUser) => {
  if (
    props.author_visible &&
    props.author &&
    typeof props.author !== "undefined" &&
    !isVenueUser
  ) {
    let userType = props.author.user_type
      ? props.author.user_type
      : props.user_type;
    switch (userType) {
      case "Agency":
        return `${props.author.first_name} ${props.author.surname} (Agent)`;
      case "Corporate":
        return `${props.author.first_name} ${props.author.surname} (Corporate)`;
      default:
        return `${props.author.first_name} ${props.author.surname} (Edge Team)`;
    }
  } else {
    switch (props.user_type) {
      case "Agency":
        return `Agent Insight`;
      case "Corporate":
        return `Corporate Insight`;
      default:
        return `Edge Insight`;
    }
  }
};

export { SiteVisitAuthorHelper };
